"use client"

import { sizes } from "@/ui/theme/sizes"
import styled from "@emotion/styled"
import { Box } from "@mui/material"

interface IconWithBackgroundProps {
  icon: React.ReactNode
  backgroundColor: string
  size?: number
}

const StyledContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "bgcolor" && prop !== "size",
})<{ bgcolor?: string; size?: number }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  width: ${(props) => `${props.size}px`};
  height: ${(props) => `${props.size}px`};
  background-color: ${(props) =>
    props.bgcolor?.startsWith("#") ? props.bgcolor : `#${props.bgcolor}`};
  padding: 10px;
  border-radius: ${sizes.baseSingle};

  & > img {
    position: relative; // Ensures the same look regardless of the content without using !important
    display: flex;
    justify-content: center;
    align-items: center;
    object-fit: contain;
  }
`

const IconWithBackground = ({
  icon,
  backgroundColor,
  size = 48,
}: IconWithBackgroundProps) => {
  return (
    <StyledContainer bgcolor={backgroundColor} size={size}>
      {icon && icon}
    </StyledContainer>
  )
}

export default IconWithBackground
